import { useState } from 'react';

export default function OrdersFilters(props: any) {
    const { onFilterChange } = props;
    const [activeFilter, setActiveFilter] = useState<string>('All Orders');

    const filters = [
        'All Orders',
        'Received',
        'Ready to Pack',
        'Shipped',
        'Delivered',
        'Canceled',
        'Payment Failed'
    ];

    const handleFilterClick = (filter: string) => {
        setActiveFilter(filter);
        if (onFilterChange) {
            onFilterChange(filter);
        }
    };

    return (
        <div className="orders_filters">
            {filters.map((filter) => (
                <div
                    key={filter}
                    className={`filter_button ${activeFilter === filter ? 'order_filter_active' : ''}`}
                    onClick={() => handleFilterClick(filter)}
                >
                    {filter}
                </div>
            ))}
        </div>
    )
}